import { render, staticRenderFns } from "./music-upload.vue?vue&type=template&id=2e2a822e&scoped=true&"
import script from "./music-upload.vue?vue&type=script&lang=js&"
export * from "./music-upload.vue?vue&type=script&lang=js&"
import style0 from "./music-upload.vue?vue&type=style&index=0&lang=less&"
import style1 from "./music-upload.vue?vue&type=style&index=1&id=2e2a822e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a822e",
  null
  
)

export default component.exports